import { MenuIcon } from './menu-icon'

export interface IconStructure {
  icon: string,
  iconStyle: MenuIcon
}